import axios from "axios";

const token = localStorage.getItem("token"); // Retrieve token from localStorage
if (token) {
  axios.defaults.headers.common["Authorization"] = `${token}`; // Set token as default Authorization header
}

export default axios;
